import jwtDecode from 'jwt-decode';
import { store } from '../redux';
import { authService } from '../services';

/**
 * Decodes the JWT token (only used for claims like exp or sso).
 */
export function getDecodedToken() {
  const { token } = store.getState()?.auth || {};

  if (!token) {
    if (!window.location.href.includes('/login')) {
      sessionStorage.setItem(
        'redirectAfterLogin',
        window.location.href.replace(window.location.origin, ''),
      );
    }
    authService.logout();
    return {};
  }

  try {
    return jwtDecode(token);
  } catch (err) {
    console.error('Invalid JWT:', err);
    return {};
  }
}

/**
 * Helper to retrieve the current user's role from Redux auth state.
 */
function getRole() {
  const auth = store.getState()?.auth;

  if (auth?.user?.role) return auth.user.role;

  const decodedToken: any = getDecodedToken();

  return decodedToken?.['OData:TokenService:HighestRole'] || null;
}

/**
 * Role check functions
 */
export function isReadOnly() {
  return getRole() === 'ReadOnly';
}

export function isAdmin() {
  const role = getRole();
  return role === 'Admin' || role === 'SuperAdmin';
}

export function isSuperAdmin() {
  return getRole() === 'SuperAdmin';
}

export function isSystemAdmin() {
  return getRole() === 'SystemAdmin';
}

export function isUser() {
  return getRole() === 'User';
}

/**
 * Checks if the user logged in via SSO (using the decoded token)
 */
export function isSSO() {
  return Boolean(getDecodedToken().sso);
}
